import api, { unwrap } from './client';

export async function createOrder(packageId, notes) {
  return unwrap(await api.post('/orders', { packageId, notes }));
}

export async function myOrders() {
  return unwrap(await api.get('/orders/my'));
}

export async function listAdminOrders(params = {}) {
  return unwrap(await api.get('/admin/orders', { params }));
}

export async function assignVendor(orderId, vendorId) {
  return unwrap(await api.put(`/admin/orders/${orderId}/assign-vendor`, { vendorId }));
}

// Clinic asserts they delivered the service (client 2026-07-31).
export async function markServiceDelivered(orderId, note) {
  const body = {};
  if (note) body.note = note;
  return unwrap(await api.post(`/orders/${orderId}/mark-service-delivered`, body));
}

// Customer confirms they received the service → order → COMPLETED.
export async function confirmService(orderId) {
  return unwrap(await api.post(`/orders/${orderId}/confirm-service`, {}));
}

// Save the patient's home location + auto-rerun the clinic assignment
// on the given order. Client 2026-08-28 flow — see PaymentReturn.js.
export async function savePatientLocation(orderId, { postcode, city, state }) {
  return unwrap(await api.post(`/orders/${orderId}/patient-location`, { postcode, city, state }));
}
